import React, { useEffect, ChangeEvent } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { FieldNames, PeriodTypes, ISelectOption } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { dropdownOptions, getMinEndDate } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'
import { Occurrence } from './Occurrence'
import { DateTime } from './DateTime'

export const Period = () => {
  const [{ fieldValues }, dispatch] = usePublishSchedule()
  const fieldValue = fieldValues[FieldNames.period]

  useEffect(() => {
    if (fieldValues.period === PeriodTypes.untilDate && fieldValues.endTime === undefined) {
      dispatch(setFieldValue(
        FieldNames.endTime,
        getMinEndDate(fieldValues)
      ))
    }
  }, [
    fieldValues,
    dispatch,
  ])

  return (
    <FormControl margin="normal">
      <InputLabel shrink id="auto-period-dropdown-label">
        Period
      </InputLabel>
      <Select
        id="auto-period-dropdown-select"
        onChange={
          ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
            dispatch(setFieldValue(FieldNames.period, value))
          }
        }
        value={fieldValue}
      >
        {dropdownOptions[FieldNames.period].map(({ value, label }: ISelectOption<PeriodTypes>) => (
          <MenuItem key={value} value={value}>{label}</MenuItem>
        ))}
      </Select>
      {
        fieldValue === PeriodTypes.untilOccurrence
          ? <Occurrence />
          : fieldValue === PeriodTypes.untilDate
            ? <DateTime fieldName={FieldNames.endTime} />
            : null
      }
    </FormControl>
  )
}
